import React, { useCallback, useEffect, useRef, useState } from 'react';
import './homeV3.css';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  Modal,
  Popover,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import TRIBE from '../../Assets/images/brokers.png';
import MOBILEHOME from '../../Assets/images/mobile-home.png';
import {
  CHAT_WITH_AIRA,
  FIND_AGENTS,
  PROFILE_ONBOARDING,
  REQUIREMENTS,
  VIEW_PROFILE,
} from '../../constants/route-path';
import AIRARECT from '../../Assets/images/AIRA.gif';
import { useNavigate } from 'react-router-dom';
import apis from '../../Services/api-services';
import AdvanceFiltersModal from '../../components/advance-filter-modal';
import {
  BangaloreNames,
  BangloreLocationBias,
  GOOGLE_MAPS_API_KEY,
  PEOPLE_JOINED,
  RENTVALUE,
} from '../../constants/app-constants';
import { Loader } from '@googlemaps/js-api-loader';
import {
  createQueryURl,
  sanitizeData,
  filterByLocations,
  formatBHKList,
  getUUID,
} from '../../Utils/helperUtils';
import dayjs from 'dayjs';
import PropertyListing from '../PropertyListing/propertyListing';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../Store/userSlice';
import { handleProfileRedirection } from '../../constants/enums';
import HourglassTopOutlinedIcon from '@mui/icons-material/HourglassTopOutlined';
import { useTranslation } from 'react-i18next';
import { TRANSLATIONS } from '../../Utils/translations';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import AnimatedFadeIn from '../../components/AnimatedFadeIn';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import BUILDSHOP1 from '../../Assets/images/buildshop1.png';
import NODATAFOUND from '../../Assets/images/no-prop-found.png';
import FILTERICON from '../../Assets/images/filter-icon.png';
import LocalitySearchDropdownInHome from '../../components/localitySearchPlacesAutocomplete';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CustomMultiSelectInHome from '../../components/customMultiSelectInHome';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CustomButton from '../../components/customButton';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Tooltip from '@mui/material/Tooltip';
import { BUTTON_TITLES } from '../../constants/button-titles';
import { ANALYTICS_CATEGORIES } from '../../constants/analytics-events';
import { ANALYTICS_EVENT_NAMES } from '../../constants/analytics-events-config';
import {
  sendAnalyticsEventToServer,
  trackGAEvent,
} from '../../Utils/analytics';

const HomeV3 = () => {
  const theme = useTheme();
  const lgBreakpointMatches = useMediaQuery(theme.breakpoints.up('lg'));

  const { recomendationFilters } = useSelector(
    (state) => state.userDetails || {}
  );

  const { t } = useTranslation();
  const [activeFilter, setActiveFilter] = useState('locality');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [dropDownValues, setDropDownValue] = useState({});
  const [propertyType, setPropertyType] = useState([]);
  const [selectedCity, setSelectedCity] = useState(['Bengaluru']);
  const [houseType, setHouseType] = useState([]);
  const [furnishType, setFurnishType] = useState([]);
  const [bedrooms, setBedRooms] = useState([]);
  const [locality, setLocation] = useState('');
  const [openAdvanceFilter, setOpenAdvanceFilter] = useState(false);
  const [profileDetails, setProfileDetails] = useState();
  const [isVerified, setIsVerified] = useState(false);
  const inputRef = useRef(null);
  const [extendFilter, setExtendFilter] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [budgetRange, setbudgetRange] = useState([20000, 50000000]);
  const [minBuildUp, setMinBuildUp] = useState();
  const [maxBuildUp, setMaxBuildUp] = useState();
  const [availabilityDate, setAvailabilityDate] = useState();
  const [showRecomendation, setShowRecomendation] = useState(false);
  const [matchCount, setMatchCount] = useState(0);
  const [matchStatus, setMatchStatus] = useState(true);
  const [dropLoader, setDropLoader] = useState(false);
  const [budgetApplied, setBudgetApplied] = useState(false);
  const [uiLoaded, setUiLoaded] = useState(false);
  const [rocketSearches, setRocketSearches] = useState([]);
  const [rocketSearchesLoading, setRocketSearchesLoading] = useState(true);
  const [isFocusedIndex, setIsFocusedIndex] = React.useState(null);
  const [showTooltipForCity, setShowTooltipForCity] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const autocompleteServiceRef = useRef(null);
  const debounceRef = useRef(null);

  const popOverOpen = Boolean(anchorEl);

  const disableButton =
    selectedCity.length < 1 || propertyType.length < 1 || locality.length < 1;

  const AdvanceFilProps = {
    dropDownValues,
    propertyType,
    setPropertyType,
    selectedCity,
    setSelectedCity,
    houseType,
    setHouseType,
    furnishType,
    setFurnishType,
    bedrooms,
    setBedRooms,
    budgetRange,
    setbudgetRange,
    minBuildUp,
    setMinBuildUp,
    maxBuildUp,
    setMaxBuildUp,
    availabilityDate,
    setAvailabilityDate,
    locality,
    setLocation,
    setBudgetApplied,
    budgetApplied,
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  useEffect(() => {
    if (
      houseType?.some((type) =>
        ['Warehouse', 'Showroom', 'Office', 'Shop'].includes(type)
      )
    ) {
      setBedRooms([]);
    }
  }, [houseType]);

  useEffect(() => {
    let params = `?offset=${0}&limit=${3}`;
    apis.user.getBoostHistory(params).then((response) => {
      if (response?.status === 200) {
        const { data } = response;
        setRocketSearches(data?.history?.data || []);
      }
      setRocketSearchesLoading(false);
    });
  }, []);

  useEffect(() => {
    // setLoader(true);
    checkVerifiedProfile();
    setDropLoader(true);
    apis.property
      .getDropDownValues()
      .then((response) => {
        // setLoader(false);
        setDropLoader(false);

        setDropDownValue(response.data);
      })
      .catch((err) => {
        // setLoader(false);
        setDropLoader(false);

        console.log('Error fetching dropdown values', err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const loader = new Loader({
      apiKey: GOOGLE_MAPS_API_KEY,
      version: 'weekly',
      libraries: ['places'],
    });

    loader.load().then(() => {
      autocompleteServiceRef.current =
        new window.google.maps.places.AutocompleteService();
    });
  }, []);

  const handlePropertyDisplay = () => {
    const filters = {
      ...(sanitizeData(locality) ? { locality: locality } : {}),
      ...(sanitizeData(houseType) ? { property_type: houseType } : {}),
      ...(sanitizeData(bedrooms) ? { bedroom: bedrooms } : {}),
      ...(sanitizeData(furnishType) ? { furnishing: furnishType } : {}),
      ...(sanitizeData(propertyType) ? { list_type: propertyType } : {}),
      ...(sanitizeData(selectedCity) ? { city: selectedCity } : {}),
      ...(sanitizeData(minBuildUp) && sanitizeData(maxBuildUp)
        ? {
            minimum_built_up_area: minBuildUp,
            maximum_built_up_area: maxBuildUp,
          }
        : {}),
      ...(sanitizeData(availabilityDate) && propertyType?.includes(RENTVALUE)
        ? { availability: dayjs(availabilityDate).format('YYYY-MM-DD') }
        : {}),
      ...(budgetApplied && {
        minimum_budget: budgetRange[0],
        maximum_budget: budgetRange[1],
      }),
    };
    const query = createQueryURl(filters);
    const newUUID = getUUID();
    trackGAEvent({
      category: ANALYTICS_CATEGORIES.SEARCH,
      action: 'search_in_home',
      label: `search_in_home`,
    });
    sendAnalyticsEventToServer(`search_in_home`, filters, newUUID);
    // dispatch(userActions.setRecomendationFilters(prevFilters || filters));
    navigate(`/recommendations${query}&track=${newUUID}`);
  };

  const checkVerifiedProfile = async () => {
    setUiLoaded(false);
    const { data: { profile } = {} } =
      await apis.agent.getAgentProfileCompletionStatus();

    if (!profile) return;
    setProfileDetails(profile);
    setIsVerified(profile?.is_verified);
    dispatch(userActions.setIsUserVerified(profile?.is_verified));
    if (profile?.is_owner === true || profile?.is_owner === false) {
      dispatch(userActions.setIsRoleAdmin(profile?.is_owner));
    }
    setUiLoaded(true);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getStateValues = (fil) => {
    switch (fil) {
      case 'bedrooms':
        return { state: bedrooms, setState: setBedRooms };
      case 'cities':
        return { state: selectedCity, setState: setSelectedCity };
      case 'property_types':
        return { state: houseType, setState: setHouseType };
      case 'new_list_type':
        return { state: propertyType, setState: setPropertyType };

      default:
        return;
    }
  };

  const debounce = (func, delay) => {
    return (...args) => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
      debounceRef.current = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const fetchPredictions = (input) => {
    if (!input || !autocompleteServiceRef.current) return;

    setLoading(true);

    autocompleteServiceRef.current.getPlacePredictions(
      {
        input,
        types: ['geocode', 'establishment'],
        locationBias: BangloreLocationBias,
        componentRestrictions: { country: 'in' },
      },
      (predictions, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          predictions
        ) {
          const filteredPredictions = filterByLocations(
            predictions,
            BangaloreNames
          );
          setOptions(filteredPredictions);
        } else {
          setOptions([]);
        }
        setLoading(false);
      }
    );
  };

  const handleInputChange = (e, val) => {
    setLocation(val);
    debouncedFetchPredictions(val);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFetchPredictions = useCallback(
    debounce(fetchPredictions, 300),
    []
  );

  return (
    <div className="homeV2-new-container">
      <Box className="v2-home-hero-main">
        <Box
          sx={{
            width: '100%',
            minHeight: '60vh',
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
          }}
        >
          <Box
            sx={{
              width: '60%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                color: '#FFFFFF',
                fontSize: { xs: '26px', md: '50px' },
                fontWeight: 600,
                width: '100%',
                lineHeight: { xs: '30px', md: '60px' },
                textAlign: 'center',
                letterSpacing: '0.3px',
                mb: 2,
              }}
            >
              <AnimatedFadeIn delay={0.5} direction="top">
                {'List, Connect &'}
                <br /> {'Grow with the Community.'}
              </AnimatedFadeIn>
            </Typography>
            <Typography
              sx={{
                color: '#E4E9F0',
                fontSize: '20px',
                fontWeight: 500,
                width: '100%',
                lineHeight: '28px',
                textAlign: 'center',
                mb: 1,
              }}
            >
              <AnimatedFadeIn delay={0.7} direction="top">
                {t(TRANSLATIONS.SUB_TITLES.CLOSE_FASTER)}
              </AnimatedFadeIn>
            </Typography>

            <AnimatedFadeIn delay={0.9} direction="top">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexWrap: 'wrap',
                  mb: 4,
                }}
              >
                <img src={TRIBE} width={120} alt="people" />
                <Typography
                  sx={{
                    fontSize: '20px',
                    lineHeight: '28px',
                    fontWeight: 500,
                    color: '#600DB4',
                    mx: '5px',
                    ml: 2,
                  }}
                >
                  {profileDetails?.total_users || PEOPLE_JOINED}{' '}
                </Typography>
                <Typography
                  sx={{
                    color: '#600DB4',
                    fontSize: '20px',
                    fontWeight: 500,
                    lineHeight: '28px',
                    my: '8px',
                  }}
                >
                  vREfyd agents
                </Typography>
                <CustomButton
                  category={ANALYTICS_CATEGORIES.AGENT}
                  trackEvent={ANALYTICS_EVENT_NAMES.NAVIGATE_FIND_AGENTS}
                  title={BUTTON_TITLES.FIND_AGENT}
                  onClick={() => navigate(FIND_AGENTS)}
                  size={'small'}
                  iconPosition="front"
                  type={'primary'}
                  customStyles={{ ml: 1 }}
                />
              </Box>
            </AnimatedFadeIn>

            {!extendFilter ? (
              <Box
                sx={{
                  background: 'rgba(255, 255, 255, 1)',
                  padding: '24px 20px',
                  borderRadius: '12px',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '90%',
                  cursor: 'pointer',
                  marginTop: '35px',
                  position: 'relative',
                }}
                onClick={() => setExtendFilter(true)}
              >
                <Typography
                  sx={{
                    color: '#7D7D7D',
                    fontSize: '18px',
                    fontWeight: 500,
                  }}
                >
                  {t(TRANSLATIONS.SUB_TITLES.HOME_SEARCH)}
                </Typography>
                <Box
                  sx={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  color="primary"
                  aria-label="add"
                >
                  <SearchIcon
                    sx={{ width: '24px', height: '24px', color: '#1B2538' }}
                  />
                </Box>
              </Box>
            ) : (
              <Modal
                open={extendFilter}
                onClose={() => setExtendFilter(false)}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  background: 'none',
                  position: 'absolute',
                  '& .MuiModal-backdrop': {
                    background: { lg: 'none' },
                  },
                }}
              >
                <Box
                  className="animated-div zoom-in"
                  sx={{
                    width: '86%',
                    // padding: '8px 16px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-end',
                    outline: 'none',
                    marginTop: {
                      lg: isVerified ? '150px' : '250px',
                      xs: '0',
                    },
                    zIndex: 1,
                  }}
                >
                  {/* <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'center', // Align to center horizontally
                    }}
                    transformOrigin={{
                      vertical: 'bottom', // Position popover's bottom to anchor's top
                      horizontal: 'center',
                    }}
                    sx={{
                      '.MuiBox-root': {
                        border: 'none',
                        borderRadius: '10px',
                    padding: '8px 16px',

                        boxShadow:
                          '1px 1px 7.3px 0px rgba(185, 185, 185, 0.25)',
                        cursor: 'pointer',
                        alignItems: 'center',
                        minWidth: '200px !Important',
                        maxWidth: '200px !Important',
                        width: '200px !Important',
                      },
                      '.MuiPopover-paper': {
                        minWidth: '200px !Important',
                        maxWidth: '200px !Important',
                        width: '200px !Important',
                      },
                    }}
                  >
                    {activeFilter &&
                      activeFilter !== 'locality' &&
                      dropDownValues &&
                      dropDownValues[activeFilter].map((item) => {
                        return (
                          <Box
                            sx={{
                              borderBottom: '1px solid #D2D2D2 ',
                              p: 1.5,
                              background: getStateValues(
                                activeFilter
                              ).state.includes(item.value)
                                ? '#F5EDFF'
                                : 'background.paper',
                              cursor: 'pointer',
                              fontSize: '14px',
                              width: '100%',
                              borderRadius: '8px',
                            }}
                            onClick={() => {
                              if (
                                getStateValues(activeFilter).state.includes(
                                  item.value
                                )
                              ) {
                                getStateValues(activeFilter).setState(
                                  getStateValues(activeFilter).state.filter(
                                    (i) => {
                                      return i !== item.value;
                                    }
                                  )
                                );
                              } else {
                                getStateValues(activeFilter).setState([
                                  ...getStateValues(activeFilter).state,
                                  item.value,
                                ]);
                              }
                            }}
                          >
                            {item.value}
                          </Box>
                        );
                      })}
                  </Popover> */}

                  {dropLoader ? (
                    <Box sx={{ color: '#ffffff' }}>Loading...</Box>
                  ) : (
                    <Box
                      sx={{
                        background: '#FFFFFF',
                        width: '100%',
                        boxShadow: '0px 2px 5px 0px rgba(27, 37, 56, 0.03)',
                        border: '1px solid rgba(228, 233, 240, 1)',
                        borderRadius: '12px',
                        display: 'flex',
                        flexDirection: { lg: 'row', xs: 'column' },
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          width: { lg: '70%', xs: '100%' },
                          display: 'flex',
                          flexDirection: { lg: 'row', xs: 'column' },
                          alignItems: 'center',
                          // gap: 3,
                          // paddingLeft: '8px',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            cursor: 'pointer',
                            width: {
                              xs: '100%',
                              lg: '20%',
                            },
                            minWidth: {
                              xs: '100%',
                              lg: '20%',
                            },
                            maxWidth: {
                              xs: '100%',
                              lg: '20%',
                            },
                            margin: '8px',
                            padding: '16px',
                          }}
                          onMouseEnter={() => {
                            setShowTooltipForCity(true);
                          }}
                          onMouseLeave={() => {
                            setShowTooltipForCity(false);
                          }}
                        >
                          <Tooltip
                            title="Currently serviceable only in Bengaluru."
                            arrow
                            placement="top-end"
                            sx={{
                              fontSize: '12px',
                              background: 'rgba(45, 3, 88, 1)',
                              '& .MuiBox-root': {
                                /* styles for the div */
                              },
                              '& .MuiTypography-root': {
                                /* styles for typography */
                              },
                              '& .MuiSvgIcon-root': {
                                color: 'warning.main', // example using theme color
                                fontSize: '18px',
                              },
                            }}
                          >
                            <Box
                              sx={{
                                alignItems: 'center',
                                flexDirection: 'row',
                                display: 'flex',
                                gap: '2px',
                              }}
                            >
                              <Typography
                                sx={{
                                  color: '#6C7480',
                                  fontSize: '12px',
                                  fontWeight: 400,
                                }}
                              >
                                City{' '}
                              </Typography>

                              <ErrorOutlineIcon
                                sx={{
                                  width: '12px',
                                  height: '12px',
                                  strokeWidth: '0.1px',
                                  color: 'rgba(150, 162, 178, 1)',
                                }}
                              />
                            </Box>

                            <Typography
                              sx={{
                                // padding: '8px',
                                color: '#1B2538',
                                fontSize: '14px',
                                fontWeight: 500,
                              }}
                            >
                              Bengaluru
                            </Typography>
                          </Tooltip>
                        </Box>
                        <Divider
                          sx={{
                            border: '1px solid  rgba(228, 233, 240, 1)',
                            height: '68px',
                            display: { lg: 'block', xs: 'none' },
                          }}
                          margin={'10px 0px'}
                          orientation="vertical"
                          variant="middle"
                          flexItem
                        />
                        <Box
                          sx={{
                            width: {
                              xs: '100%',
                              lg: isFocusedIndex === 'locality' ? '28%' : '20%',
                            },
                            minWidth: {
                              xs: '100%',
                              lg: isFocusedIndex === 'locality' ? '28%' : '20%',
                            },
                            maxWidth: {
                              xs: '100%',
                              lg: isFocusedIndex === 'locality' ? '28%' : '20%',
                            },
                            background:
                              isFocusedIndex === 'locality'
                                ? 'rgba(247, 240, 255, 1)'
                                : 'transparent',
                            borderRadius:
                              isFocusedIndex === 'locality' ? '8px' : '0px',
                            padding: '16px',
                            margin: '8px',
                            transition: 'all 0.3s ease',
                          }}
                          onFocus={() => setIsFocusedIndex('locality')}
                          onBlur={() => setIsFocusedIndex(false)}
                        >
                          <Typography
                            sx={{
                              color: '#6C7480',
                              fontSize: '12px',
                              fontWeight: 400,
                            }}
                          >
                            Locality <span style={{ color: 'red' }}>*</span>
                          </Typography>
                          <LocalitySearchDropdownInHome
                            options={options}
                            location={locality}
                            setLocation={setLocation}
                            handleInputChange={handleInputChange}
                            placeholder="Select"
                            iconComponent={KeyboardArrowDownIcon}
                            isLoading={dropLoader}
                            searchInput={locality}
                            setSearchInput={setLocation}
                            id={id}
                            anchorEl={anchorEl}
                            open={popOverOpen}
                            handleClose={handleClose}
                            handleClick={handleClick}
                            fromHome={true}
                            // inputRef={inputRef}
                          />
                        </Box>
                        <Divider
                          sx={{
                            border: '1px solid  rgba(228, 233, 240, 1)',
                            height: '68px',
                            display: { lg: 'block', xs: 'none' },
                          }}
                          margin={'10px 0px'}
                          orientation="vertical"
                          variant="middle"
                          flexItem
                        />
                        <Box
                          sx={{
                            width: {
                              xs: '100%',
                              lg:
                                isFocusedIndex === 'propertyType'
                                  ? '30%'
                                  : '20%',
                            },
                            minWidth: {
                              xs: '100%',
                              lg:
                                isFocusedIndex === 'propertyType'
                                  ? '30%'
                                  : '20%',
                            },
                            maxWidth: {
                              xs: '100%',
                              lg:
                                isFocusedIndex === 'propertyType'
                                  ? '30%'
                                  : '20%',
                            },
                            background:
                              isFocusedIndex === 'propertyType'
                                ? 'rgba(247, 240, 255, 1)'
                                : 'transparent',
                            borderRadius:
                              isFocusedIndex === 'propertyType' ? '8px' : '0px',
                            padding: '16px',
                            margin: '8px',
                            transition: 'all 0.3s ease',
                          }}
                          onFocus={() => setIsFocusedIndex('propertyType')}
                          onBlur={() => setIsFocusedIndex(false)}
                        >
                          <Typography
                            sx={{
                              color: '#6C7480',
                              fontSize: '12px',
                              fontWeight: 400,
                            }}
                          >
                            Looking for <span style={{ color: 'red' }}>*</span>{' '}
                          </Typography>
                          <CustomMultiSelectInHome
                            options={dropDownValues?.new_list_type}
                            value={propertyType}
                            onChange={(e) => setPropertyType(e.target.value)}
                            placeholder="Select"
                            iconComponent={KeyboardArrowDownIcon}
                            isLoading={dropLoader}
                            fromHome={true}
                          />
                        </Box>

                        <Divider
                          sx={{
                            border: '1px solid  rgba(228, 233, 240, 1)',
                            height: '68px',
                            display: { lg: 'block', xs: 'none' },
                          }}
                          margin={'10px 0px'}
                          orientation="vertical"
                          variant="middle"
                          flexItem
                        />
                        <Box
                          sx={{
                            width: {
                              xs: '100%',
                              lg:
                                isFocusedIndex === 'houseType' ? '28%' : '20%',
                            },
                            minWidth: {
                              xs: '100%',
                              lg:
                                isFocusedIndex === 'houseType' ? '28%' : '20%',
                            },
                            maxWidth: {
                              xs: '100%',
                              lg:
                                isFocusedIndex === 'houseType' ? '28%' : '20%',
                            },
                            background:
                              isFocusedIndex === 'houseType'
                                ? 'rgba(247, 240, 255, 1)'
                                : 'transparent',
                            transition: 'all 0.3s ease',
                            padding: '16px',
                            margin: '8px',
                            borderRadius:
                              isFocusedIndex === 'houseType' ? '8px' : '0px',
                          }}
                          onFocus={() => setIsFocusedIndex('houseType')}
                          onBlur={() => setIsFocusedIndex(false)}
                        >
                          <Typography
                            sx={{
                              color: '#6C7480',
                              fontSize: '12px',
                              fontWeight: 400,
                            }}
                          >
                            Property type
                          </Typography>
                          <CustomMultiSelectInHome
                            options={dropDownValues?.property_types}
                            value={houseType}
                            onChange={(e) => setHouseType(e.target.value)}
                            placeholder="Select"
                            iconComponent={KeyboardArrowDownIcon}
                            isLoading={dropLoader}
                            fromHome={true}
                          />
                        </Box>
                        <Divider
                          sx={{
                            border: '1px solid  rgba(228, 233, 240, 1)',
                            height: '68px',
                            display: { lg: 'block', xs: 'none' },
                          }}
                          margin={'10px 0px'}
                          orientation="vertical"
                          variant="middle"
                          flexItem
                        />
                        <Box
                          sx={{
                            width: {
                              xs: '100%',
                              lg: isFocusedIndex === 'bedrooms' ? '28%' : '20%',
                            },
                            minWidth: {
                              xs: '100%',
                              lg: isFocusedIndex === 'bedrooms' ? '28%' : '20%',
                            },
                            maxWidth: {
                              xs: '100%',
                              lg: isFocusedIndex === 'bedrooms' ? '28%' : '20%',
                            },
                            background:
                              isFocusedIndex === 'bedrooms'
                                ? 'rgba(247, 240, 255, 1)'
                                : 'transparent',
                            borderRadius:
                              isFocusedIndex === 'bedrooms' ? '8px' : '0px',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            padding: '16px',
                            margin: '8px',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start',
                          }}
                          onFocus={() => setIsFocusedIndex('bedrooms')}
                          onBlur={() => setIsFocusedIndex(false)}
                        >
                          <Typography
                            sx={{
                              color: '#6C7480',
                              fontSize: '12px',
                              fontWeight: 400,
                            }}
                          >
                            Bedroom
                          </Typography>
                          <CustomMultiSelectInHome
                            options={dropDownValues?.bedrooms}
                            value={bedrooms}
                            onChange={(e) => setBedRooms(e.target.value)}
                            placeholder="Select"
                            iconComponent={KeyboardArrowDownIcon}
                            isLoading={dropLoader}
                            labelSuffix={'BHK'}
                            avoidSuffix={'Studio'}
                            fromHome={true}
                          />
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          mt: { lg: 0, xs: 2 },
                          marginRight: { lg: 2, xs: 0 },
                          gap: '12px',
                        }}
                      >
                        <CustomButton
                          iconOnly={true}
                          category={ANALYTICS_CATEGORIES.SEARCH}
                          trackEvent={
                            ANALYTICS_EVENT_NAMES.ADVANCE_FILTER_APPLY
                          }
                          onClick={() => setOpenAdvanceFilter(true)}
                          icon={
                            <img
                              src={FILTERICON}
                              width={18}
                              height={18}
                              alt="filter"
                            />
                          }
                          type="tertiary"
                          customStyles={{ height: '40px', width: '40px' }}
                        />

                        <CustomButton
                          title={BUTTON_TITLES.SEARCH}
                          category={ANALYTICS_CATEGORIES.SEARCH}
                          onClick={!disableButton && handlePropertyDisplay}
                          icon={
                            <SearchOutlinedIcon
                              sx={{
                                width: '18px',
                                height: '18px',
                                color: '#FFFFFF',
                              }}
                            />
                          }
                          customStyles={{
                            cursor: disableButton ? 'not-allowed' : 'pointer',
                          }}
                          setDisable={disableButton}
                        />
                      </Box>
                    </Box>
                  )}
                </Box>
              </Modal>
            )}
          </Box>
        </Box>
      </Box>

      {/* Recent rocket searches */}
      <Box sx={{ width: '100%', padding: '20px 80px' }}>
        {!rocketSearchesLoading && (
          <>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: 'center',
              }}
            >
              <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>
                Recent <span style={{ color: '#600DB4' }}>rocket</span> searches
              </Typography>
              {rocketSearches?.length > 0 && (
                <CustomButton
                  category={ANALYTICS_CATEGORIES.BOOST}
                  title={BUTTON_TITLES.VIEW_ALL}
                  trackEvent={ANALYTICS_EVENT_NAMES.BOOST_VIEW_ALL}
                  onClick={() => navigate(REQUIREMENTS)}
                  onlyText={true}
                  icon={<KeyboardArrowRightOutlinedIcon />}
                  iconPosition="end"
                />
              )}
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                justifyContent: 'flex-start',
                gap: 3,
                marginTop: '10px',
              }}
            >
              {rocketSearches?.length > 0 ? (
                rocketSearches?.map((item, index) => (
                  <Box
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    sx={{
                      width: { xs: '100%', lg: '35%' },
                      cursor: 'pointer',
                      height: '175px',
                      border: '1px solid rgba(228, 233, 240, 1)',
                      padding: '20px 16px',
                      borderRadius: '8px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      background:
                        'radial-gradient(75.98% 69.85% at 100% -21.84%,  #E6DAF2 0%, #E9D8FF 6.86%,  #FCFAFF) 100%',
                      transition: 'all 0.3s ease-in-out',
                      ':hover ': {
                        background:
                          'radial-gradient(102.26% 253.24% at -5.6% 133.91%, #E6DAF2 0%, #E9D8FF 25.41%, #FCFAFF 100%)',
                        border: '1px solid  rgba(230, 218, 242, 1)',
                        boxShadow: '0px 0px 0px 2px #F7F0FF',
                        transition: 'all 0.3s ease-out-in',
                        gap: '40px',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        width: '100%',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: '18px',
                            lineHeight: '28px',
                            color:
                              hoveredIndex === index ? '#600DB4' : '#1B2538',
                          }}
                        >
                          {item?.request_data?.locality?.split(',')[0].trim() ||
                            '-'}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '20px',
                            color: '#1B2538',
                          }}
                        >
                          {formatBHKList(item?.request_data?.bedroom)}
                        </Typography>
                      </Box>
                      {item.is_property_found && (
                        <Box
                          sx={{
                            border: '1px solid rgba(183, 223, 186, 1)',
                            borderRadius: '72px',
                            background: '#EBF9EB',
                            padding: '4px 8px',
                            color: '#3D9A50',
                            fontSize: '10px',
                            fontWeight: 400,
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            width: 'fit-content',
                          }}
                        >
                          New listings
                        </Box>
                      )}
                    </Box>
                    <Box
                      sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          justifyContent: 'flex-start',
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '20px',
                            color: '#7C8694',
                          }}
                        >
                          Looking for
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '20px',
                            color: '#1B2538',
                          }}
                        >
                          <span
                            style={{
                              cursor:
                                item?.request_data?.list_type &&
                                item?.request_data?.list_type?.join(', ')
                                  .length > 20
                                  ? 'pointer'
                                  : 'default',
                            }}
                            title={
                              item?.request_data?.list_type
                                ? item?.request_data?.list_type?.join(', ')
                                : ''
                            }
                          >
                            {item?.request_data?.list_type &&
                            item?.request_data?.list_type?.join(', ').length >
                              20 ? (
                              <span
                                style={{
                                  position: 'relative',
                                  display: 'inline-block',
                                }}
                              >
                                {item.request_data?.list_type
                                  ?.join(', ')
                                  .slice(0, 20) + '...'}
                                <span
                                  style={{
                                    visibility: 'hidden',
                                    backgroundColor: '#2D0358',
                                    color: '#fff',
                                    textAlign: 'center',
                                    borderRadius: '6px',
                                    padding: '8px 12px',
                                    position: 'absolute',
                                    zIndex: 1,
                                    bottom: '125%',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    whiteSpace: 'pre-line',
                                    fontSize: '12px',
                                    minWidth: '220px',
                                    maxWidth: '300px',
                                    wordBreak: 'break-word',
                                    opacity: 0,
                                    transition: 'opacity 0.3s',
                                  }}
                                  className="lookingFor-tooltip"
                                >
                                  {item.request_data?.list_type?.join(', ')}
                                </span>
                              </span>
                            ) : (
                              item.request_data?.list_type?.join(', ')
                            )}
                          </span>
                          <style>
                            {`
                      .lookingFor-tooltip {
                        pointer-events: none;
                      }
                      span[title]:hover .lookingFor-tooltip,
                      span[title]:focus .lookingFor-tooltip {
                        visibility: visible !important;
                        opacity: 1 !important;
                        pointer-events: auto;
                      }
                    `}
                          </style>
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          justifyContent: 'flex-start',
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '20px',
                            color: '#7C8694',
                          }}
                        >
                          Property type
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '20px',
                            color: '#1B2538',
                          }}
                        >
                          <span
                            style={{
                              cursor:
                                item?.request_data?.property_type &&
                                item?.request_data?.property_type?.join(', ')
                                  .length > 20
                                  ? 'pointer'
                                  : 'default',
                            }}
                            title={
                              item?.request_data?.property_type
                                ? item?.request_data?.property_type?.join(', ')
                                : ''
                            }
                          >
                            {item?.request_data?.property_type &&
                            item?.request_data?.property_type?.join(', ')
                              .length > 20 ? (
                              <span
                                style={{
                                  position: 'relative',
                                  display: 'inline-block',
                                }}
                              >
                                {item?.request_data?.property_type
                                  ?.join(', ')
                                  .slice(0, 20) + '...'}
                                <span
                                  style={{
                                    visibility: 'hidden',
                                    backgroundColor: '#2D0358',
                                    color: '#fff',
                                    textAlign: 'center',
                                    borderRadius: '6px',
                                    padding: '8px 12px',
                                    position: 'absolute',
                                    zIndex: 1,
                                    bottom: '125%',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    whiteSpace: 'pre-line',
                                    fontSize: '12px',
                                    minWidth: '220px',
                                    maxWidth: '300px',
                                    wordBreak: 'break-word',
                                    opacity: 0,
                                    transition: 'opacity 0.3s',
                                  }}
                                  className="propertyType-tooltip"
                                >
                                  {item?.request_data?.property_type?.join(
                                    ', '
                                  )}
                                </span>
                              </span>
                            ) : (
                              item?.request_data?.property_type?.join(', ')
                            )}
                          </span>
                          <style>
                            {`
                      .propertyType-tooltip {
                        pointer-events: none;
                      }
                      span[title]:hover .propertyType-tooltip,
                      span[title]:focus .propertyType-tooltip {
                        visibility: visible !important;
                        opacity: 1 !important;
                        pointer-events: auto;
                      }
                    `}
                          </style>
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ))
              ) : (
                <Box
                  sx={{
                    borderRadius: '8px',
                    background: '#F9FAFC',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    padding: '20px 16px',
                  }}
                >
                  <img src={NODATAFOUND} alt="No Data Found" width="130px" />
                  <Typography
                    sx={{
                      mt: 3,
                      mb: 1,
                      color: '#6C7480',
                      fontWeight: 500,
                      fontSize: '16px',
                    }}
                  >
                    You do not have any requirements right now.
                  </Typography>
                </Box>
              )}
            </Box>
          </>
        )}
        {!isVerified && profileDetails?.verification_status !== 'Initiated' && (
          <>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'center',
                alignItems: 'center',
                my: { xs: '40px', md: '80px' },
                padding: { xs: '0 20px ', md: '0px 0px 0 50px' },
                gap: { xs: 4, md: 0 },
              }}
            >
              <Box
                sx={{
                  width: { xs: '100%', md: '50%' },
                  mb: { xs: 3, md: 0 },
                  mt: { xs: 3, md: 0 },
                }}
              >
                <Typography
                  sx={{
                    color: '#1B2538',
                    fontWeight: 400,
                    fontSize: { xs: '13px', md: '14px' },
                    lineHeight: { xs: '18px', md: '20px' },
                  }}
                >
                  Showcase your expertise, stand out and
                </Typography>
                <Typography
                  sx={{
                    color: '#600DB4',
                    fontWeight: 500,
                    mb: '24px',
                    fontSize: { xs: '22px', md: '28px' },
                    lineHeight: { xs: '32px', md: '42px' },
                    letterSpacing: '-0.5px',
                  }}
                >
                  Build your Digital Shop
                </Typography>
                <Typography
                  sx={{
                    color: '#6C7480',
                    fontWeight: 400,
                    fontSize: { xs: '13px', md: '14px' },
                    lineHeight: { xs: '20px', md: '24px' },
                    width: { xs: '100%', md: '90%' },
                  }}
                >
                  Complete your broker profile, highlight your local knowledge,
                  and start adding listings to build your own digital shop. Gain
                  visibility, build trust, and connect with the right clients,
                  faster. With vREfyd, you're not just listing properties,
                  you're growing your personal brand.
                </Typography>
                <CustomButton
                  category={ANALYTICS_CATEGORIES.AGENT}
                  trackEvent={ANALYTICS_EVENT_NAMES.SETUP_SHOP}
                  title="Setup Shop"
                  size={'lg'}
                  customStyles={{ marginTop: '30px' }}
                  onClick={() => navigate(PROFILE_ONBOARDING)}
                />
              </Box>

              <Box
                sx={{
                  width: { xs: '100%', md: '40%' },
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // mt: { xs: 3, md: 0 },
                }}
              >
                <img
                  src={BUILDSHOP1}
                  width={undefined}
                  style={{
                    padding: '5px',
                    // width: '90%',
                    // maxWidth: 400,
                    minWidth: 180,
                    objectFit: 'contain',
                  }}
                  alt="Build your Digital Shop"
                />
              </Box>
            </Box>

            {/* <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'column-reverse', md: 'row' },
                justifyContent: 'center',
                alignItems: 'center',
                // mt: '100px',
                // mb: '120px',
                my: { xs: '40px', md: '90px' },
                padding: { xs: '0 20px ', md: '0px 0px 0 50px' },
                gap: { xs: 4, md: 0 },
              }}
            >
              <Box
                sx={{
                  width: { xs: '100%', md: '40%' },
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // mt: { xs: 3, md: 0 },
                }}
              >
                <img
                  src={BUILDSHOP1}
                  width={undefined}
                  style={{
                    padding: '5px',
                    // width: '90%',
                    // maxWidth: 400,
                    minWidth: 180,
                    objectFit: 'contain',
                  }}
                  alt="Build your Digital Shop"
                />
              </Box>
              <Box
                sx={{
                  width: { xs: '100%', md: '50%' },
                  mb: { xs: 3, md: 0 },
                  mt: { xs: 4, md: 0 },
                  paddingLeft: '50px',
                }}
              >
                <Typography
                  sx={{
                    color: '#1B2538',
                    fontWeight: 400,
                    fontSize: { xs: '13px', md: '14px' },
                    lineHeight: { xs: '18px', md: '20px' },
                  }}
                >
                  Showcase your expertise, stand out and
                </Typography>
                <Typography
                  sx={{
                    color: '#600DB4',
                    fontWeight: 500,
                    mb: '24px',
                    letterSpacing: '-0.5px',
                    fontSize: { xs: '22px', md: '28px' },
                    lineHeight: { xs: '32px', md: '42px' },
                  }}
                >
                  Build your Digital Shop
                </Typography>
                <Typography
                  sx={{
                    color: '#6C7480',
                    fontWeight: 400,
                    fontSize: { xs: '13px', md: '14px' },
                    lineHeight: { xs: '20px', md: '24px' },
                  }}
                >
                  Complete your broker profile, highlight your local knowledge,
                  and start adding listings to build your own digital shop. Gain
                  visibility, build trust, and connect with the right clients,
                  faster. With vREfyd, you're not just listing properties,
                  you're growing your personal brand.
                </Typography>

                <CustomButton
                  title="Setup Shop- it’s Free!"
                  size={'lg'}
                  customStyles={{ marginTop: '30px' }}
                  onClick={() => navigate(PROFILE_ONBOARDING)}
                />
              </Box>
            </Box> */}
          </>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          padding: { xs: '20px', md: '40px 80px' },
        }}
      >
        <Typography
          sx={{
            width: { lg: '45%', xs: '90%' },
            fontSize: { lg: '14px', xs: '12px' },
            fontWeight: 400,
            color: '#474747',
          }}
        >
          {t(TRANSLATIONS.PARAGRAPHS.AIRA_INTRO)}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            background: '#fefefe',
            boxShadow: '4px 4px 24.8px 0px rgba(135, 135, 135, 0.25)',
            alignItems: 'center',
            color: '#474747',
            fontSize: '16px',
            fontWeight: 500,
            cursor: 'pointer',
            borderRadius: '8px',
            zIndex: 999,
            width: '180px',
            transition: 'box-shadow 0.2s ease-in-out',
            '&:hover': {
              boxShadow: '6px 6px 40px 0px rgba(135, 135, 135, 0.45)',
            },
          }}
          onClick={() => {
            trackGAEvent({
              category: ANALYTICS_CATEGORIES.AIRA,
              action: 'talk_to_aira_click',
              label: `Talk to Aira`,
            });
            sendAnalyticsEventToServer(`talk_to_aira_click`);
            navigate(CHAT_WITH_AIRA);
          }}
        >
          <img
            src={AIRARECT}
            width={'100%'}
            alt="talk to AIRA"
            style={{
              cursor: 'pointer',
              borderRadius: '8px',
            }}
          />
        </Box>
      </Box>

      <AdvanceFiltersModal
        {...AdvanceFilProps}
        handleSubmit={handlePropertyDisplay}
        dropDownValues={{ ...dropDownValues }}
        open={openAdvanceFilter}
        setOpen={setOpenAdvanceFilter}
      />
    </div>
  );
};

const VerificationStageCard = ({ profileDetails }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        background: '#fff',
        padding: '15px',
        borderRadius: '26px 24px',
        borderBottomRightRadius: '10px',
        paddingRight: 0,
      }}
    >
      <Box
        className="start-building-box"
        sx={{
          display: 'flex',
          flexDirection: { lg: 'row', xs: 'column' },
          alignItems: { lg: 'flex-end', xs: 'center' },
          justifyContent: 'space-between',
          boxShadow: '2px 4px 6px 0px rgba(170, 170, 170, 0.3)',
          background: '#FFFFFF',
          borderRadius: '26px 24px',
          paddingRight: '0',
        }}
      >
        <Box sx={{ padding: { lg: '40px', xs: '24px' } }}>
          {profileDetails?.verification_status === 'Rejected' ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div>
                <ErrorOutlineRoundedIcon
                  sx={{ color: '#A03C42' }}
                ></ErrorOutlineRoundedIcon>
              </div>
              <Typography
                sx={{
                  color: '#A03C42',
                  fontWeight: '600',
                  fontSize: '16px',
                  paddingLeft: 1,
                }}
              >
                {t(TRANSLATIONS.SUB_TITLES.PROFILE_VERIFICATION_REJECTED)}
              </Typography>
            </div>
          ) : profileDetails?.verification_status === 'Initiated' ||
            profileDetails?.verification_status === 'Re-Initiated' ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div>
                <HourglassTopOutlinedIcon
                  sx={{ color: '#EAAA6B' }}
                ></HourglassTopOutlinedIcon>
              </div>
              <Typography
                sx={{
                  color: '#EAAA6B',
                  fontWeight: '600',
                  fontSize: '16px',
                  paddingLeft: 1,
                }}
              >
                Profile Verification Pending
              </Typography>
            </div>
          ) : (
            <div>
              <Typography
                sx={{
                  color: '#600DB4',
                  fontWeight: '600',
                  fontSize: '16px',
                }}
              >
                {t(TRANSLATIONS.PARAGRAPHS.BUILD_YOUR_OWN_DIGITAL_SHOP)}
              </Typography>
            </div>
          )}

          <Typography
            sx={{
              width: { lg: '80%', xs: '100%' },
              marginY: '15px',
              fontSize: '16px',
              fontWeight: '300',
              color: '#7D7D7D',
            }}
          >
            {profileDetails?.verification_status === 'Rejected'
              ? t(TRANSLATIONS.PARAGRAPHS.YOUR_VERIFICATION_WAS_NOT_APPROVED)
              : profileDetails?.verification_status === 'Initiated' ||
                profileDetails?.verification_status === 'Re-Initiated'
              ? t(TRANSLATIONS.PARAGRAPHS.YOUR_VERIFICATION_IS_PENDING)
              : t(TRANSLATIONS.PARAGRAPHS.SHOWCASE_YOUR_EXPERTISE)}
          </Typography>
          {profileDetails?.verification_status !== 'Initiated' &&
            profileDetails?.verification_status !== 'Re-Initiated' && (
              <Box
                className={`home-start-building ${
                  profileDetails?.verification_status === 'Rejected'
                    ? 'rejected-button'
                    : ''
                }`}
                onClick={() => handleProfileRedirection(navigate)}
              >
                {profileDetails?.verification_status === 'Rejected'
                  ? t(TRANSLATIONS.SUB_TITLES.RETRY_VERIFICATION)
                  : t(TRANSLATIONS.SUB_TITLES.START_BUILDING)}
                <Box
                  sx={{
                    width: '23px',
                    height: '23px',
                    borderRadius: '50%',
                    background: '#ffffff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  color="primary"
                  aria-label="add"
                >
                  <ArrowOutwardIcon sx={{ width: '18px', color: '#590DB4' }} />
                </Box>
              </Box>
            )}
        </Box>
        <Box
          sx={{
            padding: { lg: '16px', xs: '4px' },
            paddingBottom: 0,
          }}
        >
          <img width={182} src={MOBILEHOME} alt="mobile-picture" />
        </Box>
      </Box>
    </Box>
  );
};

const FindAgentCard = ({ profileDetails }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        background: '#fff',
        padding: '15px',
        borderRadius: '26px 24px',
        borderBottomRightRadius: '10px',
        paddingRight: { lg: '0px', sm: 'none' },
        zIndex: 99,
      }}
    >
      <Box
        className="start-building-box"
        sx={{
          display: 'flex',
          flexDirection: { lg: 'row', xs: 'column' },
          alignItems: { lg: 'flex-end', xs: 'center' },
          justifyContent: 'space-between',
          boxShadow: '2px 4px 6px 0px rgba(170, 170, 170, 0.3)',
          background: '#FFFFFF',
          backgroundColor: '#F8F8F8',
          borderRadius: '26px 24px',
          paddingRight: '0',
        }}
      >
        <Box sx={{ padding: { lg: '40px', xs: '24px' } }}>
          <div>
            <Typography
              sx={{
                color: '#600DB4',
                fontWeight: '600',
                fontSize: '16px',
              }}
            >
              {t(TRANSLATIONS.PARAGRAPHS.FIND_RIGHT_AGENT)}
            </Typography>
          </div>

          <Box
            sx={{
              display: 'flex',
              marginTop: '14px',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
              my: 2,
            }}
          >
            <img src={TRIBE} width={120} alt="people" />
            <Typography className="home-500-text">
              {profileDetails?.total_users || PEOPLE_JOINED}{' '}
            </Typography>
            <Typography
              className="home-500-innertext"
              sx={{
                color: '#590db4',
                fontWeight: '600',
                fontSize: '16px',
              }}
            >
              {t(TRANSLATIONS.SUB_TITLES.VREFYD_AGENTS)}
            </Typography>
          </Box>

          <Box
            className={`home-start-building`}
            sx={{ my: 1 }}
            onClick={() => navigate(FIND_AGENTS)}
          >
            {t(TRANSLATIONS.SUB_TITLES.FIND_AGENT)}
            <Box
              onClick={() => navigate(FIND_AGENTS)}
              sx={{
                width: '23px',
                height: '23px',
                borderRadius: '50%',
                background: '#ffffff',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mr: 1,
              }}
              color="primary"
              aria-label="add"
            >
              <ArrowOutwardIcon
                sx={{ width: '18px', color: '#590DB4' }}
                onClick={() => navigate(FIND_AGENTS)}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HomeV3;
